<template>
  <div class="content">
    <s-location notice title="FAQ <small>자주 묻는 질문</small>"/>

				<!-- <h4 class="sub_title02">공지사항</h4> -->

        <div class="right mb10">
            <i-input-sel v-model="search.search_type" itemsp="all / 전체 | titl  / 제목 | cont / 내용 | name  / 작성자" />
            <input type="text" v-model="search.kword" @keyup.enter="doSearch()"
              class="sch_input " title="검색" placeholder="검색(제목, 내용)" />
            <a @click.prevent="doSearch()" class="btn icon search_black2 ">검색</a>
        </div>

        <div class="sub_tabmenu">
          <ul class="d07">
            <li :class="{ 'on' : search.faqcate == 'ALL'    }" @click="getData($event, 'ALL'   , 1)">전체</li>
            <li :class="{ 'on' : search.faqcate == 'BUY'    }" @click="getData($event, 'BUY'   , 1)">증표구입</li>
            <li :class="{ 'on' : search.faqcate == 'USE'    }" @click="getData($event, 'USE'   , 1)">증표사용</li>
            <li :class="{ 'on' : search.faqcate == 'REQ'    }" @click="getData($event, 'REQ'   , 1)">신고신청</li>
            <li :class="{ 'on' : search.faqcate == 'APPLY'  }" @click="getData($event, 'APPLY' , 1)">귀속수임사건 신고</li>
            <li :class="{ 'on' : search.faqcate == 'REPORT' }" @click="getData($event, 'REPORT', 1)">수임사건 조회</li>
            <li :class="{ 'on' : search.faqcate == 'ETC'    }" @click="getData($event, 'ETC'   , 1)">기타</li>
          </ul>
        </div>

        <s-loading v-if="list.loading"/>

				<!-- 테이블 -->
        <table class="tbl01 view01">

          <template v-for="(item,idx) in list.items" >

            <tr :key="'tr1_'+idx" @click="item.show = !item.show" v-cursor class="faq_q">
              <td><p>Q.</p></td>
              <td class="al_l" >
                <span v-html="item.titl" />
              </td>
            </tr>

            <!-- <tr :key="'tr2_'+idx" @click="item.show = !item.show">
              <td class="faq_a">A.</td>
              <td class="al_l" style="cursor: pointer">답변입니다.</td>
            </tr> -->

            <tr :key="'tr3_'+idx" class=" faq_a" v-if="item.show">
              <td ><p>A.</p></td>
              <td class="al_l">
                <span v-html="item.answ" />
              </td>
            </tr>

          </template>
        </table>
				<!-- //테이블 -->

			    <!-- paging -->
				<div class="paging" v-if="list.totalCount > search.listSize">
					<p class="num">
               <s-page :pageNo.sync="search.pageNo" :totalCount="list.totalCount" :listSize="search.listSize" @changePage="doSearch"/>
					</p>
				</div>
				<!-- /paging -->
			</div> <!-- content : width=950px; -->

</template>


<script>
let ui
export default {
  data() {
    return {
      search_init: { kword : '', listSize : 10, pageNo : 1, },
      search: {},
      list: { loading: false, items: [], totalCount: 0 },
      item_seq : '',
    }
  },
  watch: {
    '$route': "initData"
  },
  created() {
    ui = this.$ui
    this.search = _.cloneDeep(this.search_init)
    if (this.$route.query.seq){
      this.item_seq = this.$route.query.seq
    }
    this.getData(null,'ALL',1);
  },
  methods: {
    initData(){ // 현재 메뉴 다시 클릭 시
      this.search = T.deepCopy(this.search_init)
      this.getData(null,'ALL',1)
    },
    doSearch(pageNo = 1) {
      this.search.pageNo = pageNo
      this.getData(null,null,this.search.pageNo)
      //this.$router.push({ query: this.search })
    },
    getData(e, faqcate, pageNo) {

      this.search.faqcate = faqcate || this.search.faqcate
      this.search.pageNo  = pageNo || this.search.pageNo

      //T.setAttrs(this.search, this.$route.query, this.search_init)
      ui.httpGetList(this.list,
        "/proc/N_FAQ_SEL_LIST",
        {
            iv_mode           : 'FRONT',
            strfromday        : '',
            strtoday          : '',
            iv_pgsize         : this.search.listSize,
            iv_page           : this.search.pageNo,
            iv_search_text    : this.search.kword,
            iv_search_type    : 'titl_cont',
            iv_search_faqcate : this.search.faqcate,
        },
        ret => {
          this.list.totalCount = _.get(ret, "data.rs1[0].tot_rows", 0)
          this.list.items      = _.get(ret, "data.rs2", []).map(v=>{v.seq == this.item_seq ? v.show = true : v.show = false; return v})

        })

    },
  },
}
</script>
<style scoped>
  /* FAQ 자주 묻는 질문 */
  .tbl01 tr td:first-child { padding:9px 0;}
  .tbl01 tr td:first-child p{ width:22px; height:22px; padding:5px; font-size: 16px; font-weight: 700; }
  .tbl01 tr td:first-child { width:50px;padding-left:5px;}
  .tbl01 tr.faq_q td:first-child p{ color:#cf3f32; border:1px solid #b44e45;}
  .tbl01 tr.faq_a td:first-child p{ background-color:#357ace; color:#fff;}
  .tbl01 tr.faq_a td { background-color: #f5f5f5;vertical-align: top; padding:20px auto; }
  .tbl01 td { border-left:none; font-size:15px; padding:15px 10px ; border-right:none;}
  .sub_tabmenu ul li {width:13%; }

  @media screen and (max-width:720px){
    .sub_tabmenu ul li {width:auto; margin:0 1px 1px 0 ; float:left; text-align: center; padding:12px 0; font-size: 13px; cursor: pointer; letter-spacing: -2px;}
    .tbl01.view01 td {  padding:12px 0 0 0;}
    .sub_tabmenu ul li:nth-child(1), .sub_tabmenu ul li:nth-child(5) { width:110px !important;}
  }


</style>